import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { Tabs } from '../../ds';
import { Page, PageHeader, Section } from '../../components/page';
import SchoolInterviewerSettings from './SchoolInterviewerSettings';
import RetentionSettings from './RetentionSettings';
import BrandVoiceSettings from './BrandVoiceSettings';
import PanelViewSettings from './PanelViewSettings';
import ProcessSettings from './ProcessSettings';
import CvScoringSettings from './CvScoringSettings';
import BiasCheckSettings from './BiasCheckSettings';

// Email Delivery (per-account SMTP) removed: all candidate email goes through
// the Messages module now, so a separate sender setting here only confused.
//
// In the People look (29 Oct 2026): one page, its parts as tabs across the
// top (views inside one page, not a second menu). Brand guideline: how
// every Hiring AI writes and speaks (MSG-SYS10, 30 Oct 2026). Interview
// panels: what a later panel sees of earlier rounds (HIR-TC2, 1 Nov 2026).
// Recruitment process: the versioned weights, pass mark and the exit-filter
// conductors (HIR-GL1, 1 Nov 2026).
//
// Messages and Reports moved out (owner, 29 Oct 2026): which automatic
// messages go, with their wording, is each one's page in Messages → Communications; who gets which
// report is on Reports. Their old links land there.
const TABS = [
  { value: 'school', label: 'School & Interviewer' },
  { value: 'voice', label: 'Brand guideline' },
  { value: 'process', label: 'Recruitment process' },
  { value: 'cvscoring', label: 'CV scoring' },
  { value: 'bias', label: 'Bias check' },
  { value: 'panels', label: 'Interview panels' },
  { value: 'retention', label: 'Data retention' },
];
const MOVED = { messages: '/messages?view=campaigns', reports: '/reports/daily-hiring' };

const SettingsPage = () => {
  // ?tab=messages opens a tab directly — the message-pause banner links here.
  const [params, setParams] = useSearchParams();
  const wanted = params.get('tab');
  const activeTab = TABS.some((t) => t.value === wanted) ? wanted : 'school';
  const setTab = (value) => setParams(value === 'school' ? {} : { tab: value }, { replace: true });
  const current = TABS.find((t) => t.value === activeTab);
  if (MOVED[wanted]) return <Navigate to={MOVED[wanted]} replace />;

  return (
    <Page>
      <PageHeader title="Settings" subtitle="How Hiring works at this school: the interviewer, the AI's brand guideline and data retention." />
      <Tabs items={TABS} value={activeTab} onChange={setTab} />
      <Section title={current.label}>
        {/* The older settings screens keep their own styling inside the card for now. */}
        <div className={['voice', 'panels', 'process', 'cvscoring', 'bias'].includes(activeTab) ? undefined : 'dps-legacy'}>
          {activeTab === 'school' && <SchoolInterviewerSettings />}
          {activeTab === 'voice' && <BrandVoiceSettings />}
          {activeTab === 'process' && <ProcessSettings />}
          {activeTab === 'cvscoring' && <CvScoringSettings />}
          {activeTab === 'bias' && <BiasCheckSettings />}
          {activeTab === 'panels' && <PanelViewSettings />}
          {activeTab === 'retention' && <RetentionSettings />}
        </div>
      </Section>
    </Page>
  );
};

export default SettingsPage;
